/* Routine: de maatkeuze per stap houdt de bedragen bij.

   Progressieve verbetering. Zonder dit bestand blijft de keuze werken — de
   keuzelijst is een echt formulierveld en de knop post een gewone form, dus je
   krijgt precies de maten die je hebt aangewezen in je winkelwagen. Alleen de
   bedragen op het scherm blijven dan staan op de maat die er bij het laden in
   stond.

   Haken zijn data-attributen:
     [data-routine]          het blok waarbinnen wordt opgeteld (één per tabblad)
     [data-routine-item]     één stap; draagt data-prijs en data-vergelijk
     [data-routine-maat]     de keuzelijst; de optie draagt dezelfde twee
     [data-routine-bedrag]   waar de prijs van die ene stap staat
     [data-routine-totaal]   het totaal
     [data-routine-los]      wat de losse prijs is, en het blok eromheen
     [data-routine-bespaart] het verschil
*/

(function () {
  'use strict';

  function geld(cent) {
    try {
      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
      }).format(cent / 100);
    } catch (e) {
      return (cent / 100).toFixed(2);
    }
  }

  function getal(waarde) {
    var n = parseInt(waarde, 10);
    return isNaN(n) ? null : n;
  }

  /* Elke maat heeft bij Keune zijn eigen foto. Zonder dit blijft er bij "1000ml"
     een reisflacon staan, en dat is een verkeerde afbeelding en geen detail.

     srcset moet weg voordat src iets doet: het beeld is responsive gerenderd, en
     zolang de srcset er staat kiest de browser dáár een bestand uit en negeert
     hij de nieuwe src. */
  function beeldWisselen(item, keuze) {
    if (!keuze || keuze.selectedIndex < 0) return;
    var bron = keuze.options[keuze.selectedIndex].dataset.beeld;
    if (!bron) return;

    var beeld = item.querySelector('[data-routine-beeld] img') || item.querySelector('img');
    if (!beeld || beeld.getAttribute('src') === bron) return;

    // Zacht wisselen zit in theme.js: eerst inladen, dan vervagen. Is dat
    // bestand er niet, dan hard wisselen — beter een schok dan een foto die
    // bij de verkeerde maat blijft staan.
    if (window.ncBeeldWissel) {
      window.ncBeeldWissel(beeld, bron);
      return;
    }

    beeld.removeAttribute('srcset');
    beeld.removeAttribute('sizes');
    beeld.setAttribute('src', bron);
  }

  function bijwerken(blok) {
    var totaal = 0;
    var los = 0;

    blok.querySelectorAll('[data-routine-item]').forEach(function (item) {
      var keuze = item.querySelector('[data-routine-maat]');
      var prijs = getal(item.dataset.prijs);
      var vergelijk = getal(item.dataset.vergelijk);

      if (keuze && keuze.selectedIndex >= 0) {
        var optie = keuze.options[keuze.selectedIndex];
        prijs = getal(optie.dataset.prijs);
        vergelijk = getal(optie.dataset.vergelijk);
      }

      // Geen prijs betekent: uitverkocht, en die telt niet mee. Zou hij dat wel
      // doen, dan belooft "Samen €67,80" iets anders dan er in de winkelwagen
      // belandt — de knop slaat uitverkochte producten immers over.
      if (prijs === null) return;

      var bedrag = item.querySelector('[data-routine-bedrag]');
      if (bedrag) bedrag.textContent = geld(prijs);

      beeldWisselen(item, keuze);

      totaal += prijs;
      los += vergelijk === null || vergelijk < prijs ? prijs : vergelijk;
    });

    var vak = blok.querySelector('[data-routine-totaal]');
    if (vak) vak.textContent = geld(totaal);

    var losvak = blok.querySelector('[data-routine-los]');
    if (losvak) losvak.textContent = geld(los);

    var verschil = los - totaal;
    var bespaartvak = blok.querySelector('[data-routine-bespaart]');
    if (bespaartvak) bespaartvak.textContent = geld(verschil);

    // De hele regel weg als er niets te besparen valt: "je bespaart €0,00" is
    // geen mededeling.
    var losblok = blok.querySelector('[data-routine-los-blok]');
    if (losblok) losblok.hidden = verschil <= 0;
  }

  function init(wortel) {
    wortel.querySelectorAll('[data-routine]').forEach(function (blok) {
      if (blok.dataset.klaar === 'ja') return;
      blok.dataset.klaar = 'ja';

      blok.addEventListener('change', function (e) {
        if (e.target.matches('[data-routine-maat]')) bijwerken(blok);
      });

      // Eén keer bij het laden: de browser herstelt bij een terugknop de eerder
      // gekozen maat in de lijst, en dan hoort het bedrag daarbij te passen.
      bijwerken(blok);
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
